














































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import moment, {Moment} from "moment";
import 'moment/locale/fr';

@Component
export default class Calendar extends Vue {

  public dateIsVisible: boolean = false;
  public days = this.getDaysOfTheWeek();
  public today: Moment = moment().startOf('day');
  public dateContext: Moment = moment().startOf('month').startOf('day');
  public selectedDate: Moment | null = null;
  public dateIsValid: boolean = true;
  public limit = {
    minDate: moment().startOf('day').toDate() as unknown as Moment | false,
    maxDate: false as unknown as Moment | false,
  };

  @Prop({
    type: String,
    default: 'calendarId',
  })
  public calendarId!: string;

  @Prop({
    type: String,
    default: '',
  })
  public initValue!: string;

  mounted() {
    moment.locale('fr');
    if (this.initValue !== "") {
      const initDate = moment(this.initValue, 'YYYY-MM-DD');
      this.selectedDate = initDate;
      this.dateContext = initDate.clone().startOf('month').startOf('day');
    }
  };

  get year() {
    return this.dateContext.format('Y');
  };

  get month() {
    return this.dateContext.format('MMMM');
  };

  get monthNumber() {
    return this.dateContext.format('MM');
  };


  get displayDate() {
    let date = this.selectedDate;
    if (!date) return '';

    return date.format('LL');
  };

  set displayDate(date) {
  }

  get rawDate() {
    let date = this.selectedDate;
    if (!date) return '';

    return date.format(moment.HTML5_FMT.DATETIME_LOCAL)
  };

  get isoDate() {
    return this.dateContext.toDate();
  };

  get currentMonth() {
    return this.month.toString()[0].toUpperCase() + this.month.toString().slice(1) + ' ' + this.year.toString();
  };

  get daysInMonth() {
    return this.dateContext.daysInMonth();
  };

  get firstDayOfMonth() {
    let firstDay = this.dateContext.startOf('month').clone();
    return firstDay.weekday();
  };

  get initialDate() {
    return this.today.get('date');
  };

  get initialMonth() {
    return this.today.format('MM');
  };

  get initialYear() {
    return this.today.format('Y');
  };

  get previousMonth() {
    return this.dateContext.clone().subtract(1, 'month').endOf('month');
  };

  get nextMonth() {
    return this.dateContext.clone().add(1, 'month').startOf('month');
  };

  public getDaysOfTheWeek(): string[] {
    const days = [];
    for (let i = 0; i < 7; i++) {
      days.push(moment().weekday(i).format('dd')[0].toUpperCase())
    }
    return days;
  }

  public checkDateInput() {
    if (this.selectedDate) {
      this.checkDate(this.selectedDate);
      this.closeDate();
    }
  };

  public checkDate(dateMoment: any) {
    if (!dateMoment) {
      return;
    }
    this.dateIsValid = !this.isDisabledDate(dateMoment);
  };

  public addMonth() {
    if (!this.isNextMonthDisabled()) {
      this.dateContext = this.nextMonth;
    }
  };

  public subtractMonth() {
    if (!this.isPreviousMonthDisabled()) {
      this.dateContext = this.previousMonth;
    }
  };

  public isPreviousMonthDisabled() {
    return this.limit.minDate && this.previousMonth < moment(this.limit.minDate);
  };

  isNextMonthDisabled() {
    return this.limit.maxDate && this.nextMonth > this.limit.maxDate;
  };

  public selectDate(day: number) {
    if (this.isDisabledDay(day)) return;
    this.selectedDate = moment(this.getDateFromDay(day)).startOf('days');
    this.closeDate();
  };

  public openDate() {
    this.dateIsVisible = true;
  };

  public closeDate() {
    this.$emit('date-close', this.selectedDate);
    this.dateIsVisible = false;
  };

  public getDateFromDay(day: number) {
    return moment().year(this.dateContext.year()).month(this.dateContext.month()).date(day);
  };

  public isSelectedDate(day: number): boolean {
    if (!this.selectedDate) return false;
    return this.selectedDate.format("LL") === this.getDateFromDay(day).format("LL");
  };

  public isDisabledDay(day: number): boolean {
    const thisDate = this.getDateFromDay(day);
    return this.isDisabledDate(thisDate);
  }

  public isDisabledDate(momentDate: any): boolean {
    if (this.limit.maxDate && momentDate > this.limit.maxDate) return true;
    if (this.limit.minDate && momentDate < this.limit.minDate) return true;
    return false;
  }

  public getDateClasses(day: number) {
    return {
      'isToday': this.today.format("LL") === this.getDateFromDay(day).format("LL"),
      'isSelected': this.isSelectedDate(day),
      'isDisabled': this.isDisabledDay(day)
    };
  }

}

